import styled from "styled-components";
import { IStyle, ButtonStyle } from "../../types";

const ButtonDefaultStyle = styled.div<IStyle>`
  display: inline-block;
  color: ${(props) =>
    setColor(
      props.theme.buttonStyle,
      props.inverted || false,
      props.theme.primaryColor,
      props.theme.invertFontColor,
      props.theme.disabledColor
    )};
  text-decoration: ${(props) =>
    props.theme.buttonStyle === ButtonStyle.text ? "underline" : "none"};
  font-size: ${(props) =>
    props.theme.buttonStyle === ButtonStyle.text ? "16px" : "14px"};
  padding: 12px
    ${(props) =>
      props.theme.buttonStyle === ButtonStyle.text ? "12px" : "24px"};
  background-color: ${(props) =>
    setBackgroundColor(
      props.theme.buttonStyle,
      props.inverted || false,
      props.theme.primaryColor
    )};
  border: ${(props) =>
    setBorder(
      props.theme.buttonStyle,
      props.inverted || false,
      props.theme.primaryColor,
      props.theme.disabledColor
    )};
  box-shadow: ${(props) =>
    props.theme.buttonStyle === ButtonStyle.text
      ? "0px 2px 4px rgba(0, 0, 0, 0.25)"
      : "none"};
  border-radius: 3px;
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

const setColor = (
  buttonStyle: string,
  inverted: boolean,
  primaryColor: string,
  invertedColor: string,
  disabledColor: string
) => {
  switch (buttonStyle) {
    case ButtonStyle.contained:
      return inverted ? primaryColor : invertedColor;
    default:
      return inverted ? disabledColor : primaryColor;
  }
};

const setBackgroundColor = (
  buttonStyle: string,
  inverted: boolean,
  primaryColor: string
) => {
  switch (buttonStyle) {
    case ButtonStyle.contained:
      return inverted ? "transparent" : primaryColor;
    default:
      return "transparent";
  }
};

const setBorder = (
  buttonStyle: string,
  inverted: boolean,
  primaryColor: string,
  disabledColor: string
) => {
  switch (buttonStyle) {
    case ButtonStyle.contained:
      return inverted ? `1px solid ${primaryColor}` : "none";
    case ButtonStyle.outlined:
      return inverted
        ? `1px solid ${disabledColor}`
        : `1px solid ${primaryColor}`;
    default:
      return "none";
  }
};
export default ButtonDefaultStyle;
